// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-9058e750] .tit{\r\n  background: lightgrey !important;\r\n  color:black !important\n}\n[data-v-9058e750] .preview{\r\nbackground:grey lighten-4 !important\n}\r\n", ""]);
// Exports
module.exports = exports;
